import React from 'react';
import PackageCard from '../components/PackageCard';
import { Helmet } from 'react-helmet-async';
const AdditionalLessonsPage = () => {
  const additionalPackages = [{
    title: 'Refresher Driving Lessons',
    price: '£90',
    description: '£45 per hour - 2-hour package designed for full licence holders.',
    features: ['Rebuild confidence after a break from driving', 'Update your skills with current best practices', 'Address specific driving anxieties or concerns', 'Personalized coaching based on your needs'],
    link: 'https://www.totaldrive.app/a/enquiry_form.php?17584722727972'
  }, {
    title: 'Motorway Driving Lessons',
    price: '£90',
    description: '£45 per hour - 2-hour package for safe motorway driving.',
    features: ['Learn proper lane discipline and positioning', 'Practice safe entry and exit via slip roads', 'Develop skills for overtaking and speed management', 'Build confidence on high-speed roads'],
    popular: true,
    link: 'https://www.totaldrive.app/a/enquiry_form.php?17584722727972'
  }, {
    title: 'Driving Test Booking Service',
    price: '£110',
    description: 'For Northampton Driving School students only.',
    features: ['We handle the test booking process for you', "Use of instructor's car on test day", 'Pre-test warm-up lesson to calm nerves', 'Post-test feedback and guidance'],
    link: 'https://www.totaldrive.app/a/enquiry_form.php?17584722727972'
  }];
  return <div className="bg-white" data-id="element-393">
      <Helmet data-id="element-394">
        <title data-id="element-395">Refresher & Motorway Driving Lessons Northampton</title>
        <meta name="description" content="Build confidence with refresher driving lessons, motorway lessons, and driving test booking services. Affordable, local, and tailored to your needs." data-id="element-396" />
        <meta name="keywords" content="refresher driving lessons Northampton, motorway driving lessons Northampton, driving test booking Northampton, confidence building driving lessons" data-id="element-397" />
      </Helmet>
      <div className="container mx-auto px-4 py-12" data-id="element-398">
        <h1 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-399">
          Additional Driving Lessons
        </h1>
        {/* Hidden H2 tags for SEO */}
        <h2 className="sr-only" data-id="element-400">Refresher Driving Lessons Northampton</h2>
        <h2 className="sr-only" data-id="element-401">Motorway Driving Lessons Northampton</h2>
        <h2 className="sr-only" data-id="element-402">Affordable Refresher and Motorway Lessons</h2>
        <div className="mb-8" data-id="element-403">
          <p className="text-gray-700" data-id="element-404">
            Beyond our standard and intensive courses, we offer specialized
            driving lessons to help you build confidence in specific areas or
            prepare for your driving test. All lessons are conducted in
            automatic cars by our qualified instructors.
          </p>
        </div>
        {/* Refresher Lessons Section */}
        <div className="mb-16" data-id="element-405">
          <h2 className="text-2xl font-bold mb-6 border-b border-gray-200 pb-2" data-id="element-406">
            Refresher Driving Lessons
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-8" data-id="element-407">
            <div data-id="element-408">
              <p className="mb-4" data-id="element-409">
                Our refresher driving lessons are perfect for licensed drivers
                who haven't been behind the wheel for a while or who want to
                brush up on their skills. Whether you've lost confidence or
                simply need to update your knowledge of current road
                regulations, our patient instructors will help you become a
                confident driver again.
              </p>
              <div className="bg-gray-50 p-6 rounded-lg" data-id="element-410">
                <h3 className="text-xl font-semibold mb-3" data-id="element-411">Who Can Benefit?</h3>
                <ul className="space-y-2" data-id="element-412">
                  <li className="flex items-start" data-id="element-413">
                    <div className="mr-2 text-burgundy-600 mt-1" aria-hidden="true" data-id="element-414">
                      ✓
                    </div>
                    <div data-id="element-415">Drivers who haven't driven for an extended period</div>
                  </li>
                  <li className="flex items-start" data-id="element-416">
                    <div className="mr-2 text-burgundy-600 mt-1" aria-hidden="true" data-id="element-417">
                      ✓
                    </div>
                    <div data-id="element-418">
                      Those who've experienced a road incident and need to
                      rebuild confidence
                    </div>
                  </li>
                  <li className="flex items-start" data-id="element-419">
                    <div className="mr-2 text-burgundy-600 mt-1" aria-hidden="true" data-id="element-420">
                      ✓
                    </div>
                    <div data-id="element-421">
                      International license holders adapting to UK roads
                    </div>
                  </li>
                  <li className="flex items-start" data-id="element-422">
                    <div className="mr-2 text-burgundy-600 mt-1" aria-hidden="true" data-id="element-423">
                      ✓
                    </div>
                    <div data-id="element-424">
                      Drivers wanting to improve specific skills (parking,
                      roundabouts, etc.)
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div data-id="element-425">
              <PackageCard title="Refresher Driving Lessons" price="£90" description="£45 per hour - 2-hour package designed for full licence holders who want to rebuild confidence or update their skills." features={['Personalized to address your specific concerns', 'Focus on areas where you need most practice', 'Update on current road rules and regulations', 'Flexible scheduling to fit your availability']} link="https://www.totaldrive.app/a/enquiry_form.php?17584722727972" data-id="element-426" />
            </div>
          </div>
        </div>
        {/* Motorway Lessons Section */}
        <div className="mb-16" data-id="element-427">
          <h2 className="text-2xl font-bold mb-6 border-b border-gray-200 pb-2" data-id="element-428">
            Motorway Driving Lessons
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-8" data-id="element-429">
            <div data-id="element-430">
              <p className="mb-4" data-id="element-431">
                Motorway driving requires specific skills and confidence that
                many new drivers haven't had the opportunity to develop. Our
                specialized motorway lessons provide a safe, structured
                environment to learn these essential skills with an experienced
                instructor by your side.
              </p>
              <div className="bg-gray-50 p-6 rounded-lg" data-id="element-432">
                <h3 className="text-xl font-semibold mb-3" data-id="element-433">
                  What You'll Learn
                </h3>
                <ul className="space-y-2" data-id="element-434">
                  <li className="flex items-start" data-id="element-435">
                    <div className="mr-2 text-burgundy-600 mt-1" aria-hidden="true" data-id="element-436">
                      ✓
                    </div>
                    <div data-id="element-437">Safe entry and exit via slip roads</div>
                  </li>
                  <li className="flex items-start" data-id="element-438">
                    <div className="mr-2 text-burgundy-600 mt-1" aria-hidden="true" data-id="element-439">
                      ✓
                    </div>
                    <div data-id="element-440">Proper lane discipline and positioning</div>
                  </li>
                  <li className="flex items-start" data-id="element-441">
                    <div className="mr-2 text-burgundy-600 mt-1" aria-hidden="true" data-id="element-442">
                      ✓
                    </div>
                    <div data-id="element-443">Safe overtaking techniques</div>
                  </li>
                  <li className="flex items-start" data-id="element-444">
                    <div className="mr-2 text-burgundy-600 mt-1" aria-hidden="true" data-id="element-445">
                      ✓
                    </div>
                    <div data-id="element-446">Managing speed and maintaining safe distances</div>
                  </li>
                  <li className="flex items-start" data-id="element-447">
                    <div className="mr-2 text-burgundy-600 mt-1" aria-hidden="true" data-id="element-448">
                      ✓
                    </div>
                    <div data-id="element-449">Dealing with heavy traffic and adverse weather</div>
                  </li>
                </ul>
              </div>
            </div>
            <div data-id="element-450">
              <PackageCard title="Motorway Driving Lessons" price="£90" description="£45 per hour - 2-hour package for safe and structured lessons to build confidence on motorways." features={['Hands-on experience on actual motorways', 'Learn to manage high-speed driving situations', 'Develop awareness of motorway-specific hazards', 'Build confidence for independent motorway driving']} popular={true} link="https://www.totaldrive.app/a/enquiry_form.php?17584722727972" data-id="element-451" />
            </div>
          </div>
        </div>
        {/* Test Booking Section */}
        <div className="mb-16" data-id="element-452">
          <h2 className="text-2xl font-bold mb-6 border-b border-gray-200 pb-2" data-id="element-453">
            Driving Test Booking Service
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-8" data-id="element-454">
            <div data-id="element-455">
              <p className="mb-4" data-id="element-456">
                Booking your driving test can be stressful, especially when
                trying to secure a convenient date and time. Our driving test
                booking service takes care of this process for you and includes
                the use of your instructor's car for the test, ensuring you're
                comfortable with the vehicle on your big day.
              </p>
              <div className="bg-gray-50 p-6 rounded-lg" data-id="element-457">
                <h3 className="text-xl font-semibold mb-3" data-id="element-458">Service Includes</h3>
                <ul className="space-y-2" data-id="element-459">
                  <li className="flex items-start" data-id="element-460">
                    <div className="mr-2 text-burgundy-600 mt-1" aria-hidden="true" data-id="element-461">
                      ✓
                    </div>
                    <div data-id="element-462">Handling the DVSA test booking process</div>
                  </li>
                  <li className="flex items-start" data-id="element-463">
                    <div className="mr-2 text-burgundy-600 mt-1" aria-hidden="true" data-id="element-464">
                      ✓
                    </div>
                    <div data-id="element-465">Use of your instructor's dual-controlled car</div>
                  </li>
                  <li className="flex items-start" data-id="element-466">
                    <div className="mr-2 text-burgundy-600 mt-1" aria-hidden="true" data-id="element-467">
                      ✓
                    </div>
                    <div data-id="element-468">
                      Pre-test warm-up to settle nerves (1 hour before test)
                    </div>
                  </li>
                  <li className="flex items-start" data-id="element-469">
                    <div className="mr-2 text-burgundy-600 mt-1" aria-hidden="true" data-id="element-470">
                      ✓
                    </div>
                    <div data-id="element-471">Instructor accompaniment to the test center</div>
                  </li>
                  <li className="flex items-start" data-id="element-472">
                    <div className="mr-2 text-burgundy-600 mt-1" aria-hidden="true" data-id="element-473">
                      ✓
                    </div>
                    <div data-id="element-474">Post-test feedback and guidance</div>
                  </li>
                </ul>
                <p className="mt-4 text-sm text-amber-600" data-id="element-475">
                  <strong data-id="element-476">Note:</strong> This service is available to
                  Northampton Driving School students only. Cancellation charges
                  apply as per our cancellation policy.
                </p>
              </div>
            </div>
            <div data-id="element-477">
              <PackageCard title="Driving Test Booking Service" price="£110" description="Complete test day support for Northampton Driving School students only." features={['We handle the test booking process', "Use of instructor's car on test day", 'Pre-test warm-up lesson to calm nerves', 'Post-test feedback regardless of outcome']} link="https://www.totaldrive.app/a/enquiry_form.php?17584722727972" data-id="element-478" />
            </div>
          </div>
        </div>
        <div className="text-center" data-id="element-479">
          <h2 className="text-2xl font-bold mb-4" data-id="element-480">
            Ready to Enhance Your Driving Skills?
          </h2>
          <p className="text-gray-700 mb-6 max-w-2xl mx-auto" data-id="element-481">
            Contact us today to book any of our additional lessons or to discuss
            how we can help you become a more confident, skilled driver.
          </p>
          <a href="https://www.totaldrive.app/a/enquiry_form.php?17584722727972" target="_blank" rel="noopener noreferrer" className="bg-burgundy-600 hover:bg-burgundy-700 text-white px-6 py-3 rounded-md font-medium inline-block transition-colors" aria-label="Book refresher or motorway driving lessons in Northampton" data-id="element-482">
            Book Now
          </a>
        </div>
      </div>
    </div>;
};
export default AdditionalLessonsPage;